<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Datatable from '@/components/Datatable'

export default {
  page: {
    title: "Sms Raporları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable
  },
  mixins: [ datatableMixin],
  data() {
    return {
      title: "SMS RAPORLARI",
      items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "SMS RAPORLARI",
          active: true,
        }
      ],
      searchParams: {},
      columns: [
        { name: 'Gönderim Tarihi', key: 'created_at', width: 160 },
        { name: 'Kullanıcı Adı', key: 'username', width: 140 },
        { name: 'İsim Soyisim', key: 'fullname', width: 160 },
        { name: 'Telefon', key: 'phonenumber', width: 130 },
        { name: 'Mesaj', key: 'message' },
        { name: 'Durum', key: 'status', width: 120 },
      ],
      tableData: {
        detail: true,
        excel: false,
        searchable: {
          visible: true,
          placeholder: "Kullanıcı adı, isim veya telefon ara"
        }
      },
      endpoint: '/reports/sms-raporu',
      form: {
        startdate: '',
        startdateend: ''
      },
      rows: [],
    };
  },
  methods: {
    async loadPage() {
      this.params.page === 1 ? this.isLoading = true : this.pageLoading = true

      const response = await this.$http.post(this.endpoint, {
        params: this.params,
        search_params: this.searchParams,
        sort: this.sort,
        search_query: this.searchQuery
      });

      if (response.data.error) {
        this.params.page === 1 ? this.isLoading = false : this.pageLoading = false
        return
      }

      if (this.params.page === 1) {
        this.tableData.data = response.data.data;
      } else {
        this.tableData.data = [...this.tableData.data, ...response.data.data];
      }

      this.tableData.pagination = {
        current_page: response.data.current_page,
        last_page: response.data.last_page,
        total: response.data.total
      };
      this.params.page === 1 ? this.isLoading = false : this.pageLoading = false
    },
    handleFilterChange() {
      this.searchParams = this.form
      this.params.page = 1
      this.loadPage()
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <Datatable
        :columns="columns"
        :tableData="tableData"
        @sort-column="handleSortColumn"
        @search-query="reLoadPage"
        :loading="isLoading"
        :poading="pageLoading">

          <template #created_at="{ row }">
            {{ formatDate(row.created_at, 'DD.MM.YYYY HH:mm') }}
          </template>

          <template #message="{ row }">
            <span v-b-popover.hover.auto="row.message">{{ row.message }}</span>
          </template>

          <template #status="{ row }">
            <span v-if="row.status" class="badge rounded-pill bg-success">Gönderildi</span>
            <span v-else class="badge rounded-pill bg-danger">Hata</span>
          </template>

          <template #searchItems>
            <div class="col-md-4">
              <div class="mb-3">
                <label class="d-flex justify-content-between">Gönderim Tarih Aralığı
                  <span
                    v-if="form.startdate || form.startdateend"
                    class="text-danger"
                    @click="form.startdate= '' ;form.startdateend= '';handleFilterChange()">
                    temizle
                  </span>
                </label>
                <div class="input-group">
                  <input type="date" class="form-control" v-model="form.startdate" @change="handleFilterChange">
                  <button type="button" style="border:0;background: transparent;"> - </button>
                  <input type="date" class="form-control" v-model="form.startdateend" @change="handleFilterChange">
                </div>
              </div>
            </div>
          </template>
     </Datatable>
  </Layout>
</template>
